import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import PatientDetailsPage from './PatientDetailsPage.js';

export default WithGASetup(PatientDetailsPage, AuthContext);
